<template>
	<div>
		<div id="myChart"></div>
		<div class="user">
			<el-row>
				<el-col :span="6">心率数值</el-col>
				<el-col :span="6">最高心率 : {{heartInfo.max}}</el-col>
				<el-col :span="6">平均心率 : {{heartInfo.avg}}</el-col>
				<el-col :span="6">最低心率 : {{heartInfo.min}}</el-col>
			</el-row>
			<el-row>
				<el-col :span="6">心率异常</el-col>
				<el-col :span="6">心率过缓 : {{heartInfo.slowNum}}</el-col>
				<el-col :span="6">心率过快 : {{heartInfo.quickNum}}</el-col>
				<!-- <el-col :span="6">异常列表</el-col> -->
			</el-row>
		</div>


	</div>
</template>

<script>
	export default {
		props:["heartInfo"],
		data() {
			return {

			}
		},
		created() {
			// this.getHeart()
			this.getNurse()
		},
		methods: {
			
			getNurse() {
				var dateTime = [];
				var heartData = [];
				let data = new FormData();
				data.append('deviceSid', window.sessionStorage.getItem("deviceSid"));
				data.append('date', window.sessionStorage.getItem("date"));
				this.$post("api/nurseBedByDate", data).then(res => {
					res.data.map((val) => {
						var date1 = val.createTime.substring(11, 16)
						heartData.push(val.heartRate)
						dateTime.push(date1)
					})
					let myChart = this.$echarts.init(document.getElementById('myChart'))
					var option = {
						tooltip: {
							trigger: 'axis',
							position: function(pt) {
								return [pt[0], '10%'];
							}
						},
						grid: {
							top: '16%', // 等价于 y: '16%'
							left: '1%',
							right: '1%',
							bottom: '14%',
							containLabel: true
						},
						title: {
							left: 'center',
							text: '心率数据',
						},
						toolbox: {
							feature: {
								dataZoom: {
									yAxisIndex: 'none'
								},
								restore: {},
								saveAsImage: {}
							}
						},
						xAxis: {
							type: 'category',
							boundaryGap: false,
							data: dateTime
						},
						yAxis: {
							name: '次/分钟',
							type: 'value',
							boundaryGap: [0, '100%']
						},
						dataZoom: [{
							type: 'inside',
							start: 0,
							end: 10
						}, {
							start: 0,
							end: 10,
							handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
							handleSize: '80%',
							handleStyle: {
								color: '#fff',
								shadowBlur: 3,
								shadowColor: 'rgba(0, 0, 0, 0.6)',
								shadowOffsetX: 2,
								shadowOffsetY: 2
							}
						}],
						series: [{
							name: '心率值',
							type: 'line',
							smooth: true,
							symbol: 'none',
							sampling: 'average',
							itemStyle: {
								color: '#1ec7a9'
							},
							areaStyle: {
								color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: '#bdf0f0'
								}, {
									offset: 1,
									color: '#e9f0f0'
								}])
							},
							data: heartData
						}]
					}
					myChart.setOption(option);
					window.onresize = myChart.resize;

				}).catch((e) => {
					window.console.log(e)
				});
			}
		}
	}
</script>

<style scoped="scoped">
	#myChart {
		/* height: 100%; */
		height: 300px;
	}

	.user {
		height: 80px;
		width:96%;
		margin:10px auto 0;
		/* border:1px solid red; */
		background: #F1F0F5;
		border-radius: 8px;
	}

	.user .el-row {
		height: 40px;
		box-sizing: border-box;
		padding:0 24px;
	}

	.user .el-row .el-col {
		color:#4a5a6a;
		font-size:16px;
		/* margin-left: 3%; */
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
	}
	.user .el-row .el-col:first-of-type{
		font-weight:bold;
	}
</style>
